import { defineComponent, computed, getCurrentInstance } from "vue";
import IconLanguage from "@com/components/language-selector/icon-language.vue";
import { flagsIconMapper } from "@com/config/ai-support-language";
export default defineComponent({
    components: {
        IconLanguage: IconLanguage
    },
    props: {
        code: {
            type: String,
            required: true
        }
    },
    setup: function setup(props) {
        var iconResolver = function iconResolver(code) {
            return flagsIconMapper[code];
        };
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var list = computed(function() {
            var _languages;
            return (_languages = root.$store.state.config.languages) !== null && _languages !== void 0 ? _languages : [];
        });
        var item = computed(function() {
            return list.value.find(function(t) {
                return t.code === props.code;
            }) || list.value.find(function(t) {
                return t.name === props.code;
            }) || {
                name: props.code
            };
        });
        if (!list.value.length) {
            root.$store.dispatch("config/getLanguagesList");
        }
        return {
            item: item,
            iconResolver: iconResolver
        };
    }
});
